import { registerMsgHandler } from "userful-chronos-app-common-js/dist/message/messageRegistery";
import { NOTIFY_CAPACITY_LIMIT } from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/notifications/notificationMsgs";
import { CapacityAlert } from "userful-chronos-app-common-js/dist/models/notifications/notifications";
import capacityStore from "../capacityStore";
import { capacityActions } from "../capacitySlice";

registerMsgHandler(NOTIFY_CAPACITY_LIMIT, (payload) => {
    const data = JSON.parse(payload) as CapacityAlert;
    capacityStore.dispatch(capacityActions.setData(data));
});
